export enum Event {
  ConfigSaved = 'configSaved',
  DeviceConnected = 'deviceConnected',
  DeviceDisconnected = 'deviceDisconnected',
  DeviceDiscovered = 'deviceDiscovered',
  DeviceRejected = 'deviceRejected',
  DevicePaused = 'devicePaused',
  DeviceResumed = 'deviceResumed',
  DownloadProgress = 'downloadProgress',
  FolderCompletion = 'folderCompletion',
  DevicesCompletions = 'devicesCompletions',
  FolderRejected = 'FolderRejected',
  FolderSummary = 'folderSummary',
  ItemFinished = 'itemFinished',
  ItemStarted = 'itemStarted',
  LocalIndexUpdated = 'localIndexUpdated',
  RemoteIndexUpdated = 'remoteIndexUpdated',
  StartupCompleted = 'startupCompleted',
  StateChanged = 'stateChanged',
  FolderErrors = 'folderErrors',
  FolderScanProgress = 'folderScanProgress',
  FolderPaused = 'folderPaused',
  FolderResumed = 'folderResumed',
  FolderSummaries = 'folderSummaries',

  // ccs-backend
  MassCsvCheck = 'massCsvCheck',
  ExtractProgress = 'extractProgress',
  YoutubeDownloadProgress = 'youtubeDownloadProgress',
  C3Online = 'c3online',
  C3Offline = 'c3offline',
  KiwixDownloadProgress = 'KiwixDownloadProgress',
  ExportContentProgress = 'exportContentProgress',
  ExportContentReady = 'exportContentReady',
  ThumbnailGenerated = 'thumbnailGenerated',
  YoutubePlaylistVideoCheck = 'youtubePlaylistVideoCheck',
}
/*
ConfigSaved				// Emitted after the config has been saved by the user or by Syncthing itself
DeviceConnected			// Generated each time a connection to a device has been established
DeviceDisconnected		// Generated each time a connection to a device has been terminated
DeviceDiscovered		// Emitted when a new device is discovered using local discovery
DeviceRejected			// Emitted when there is a connection from a device we are not configured to talk to
DevicePaused			// Emitted when a device has been paused
DeviceResumed			// Emitted when a device has been resumed
DownloadProgress		// Emitted during file downloads for each folder for each file
FolderCompletion		//Emitted when the local or remote contents for a folder changes
FolderRejected			// Emitted when a device sends index information for a folder we do not have, or have but do not share with the device in question
FolderSummary			// Emitted when folder contents have changed locally
ItemFinished			// Generated when Syncthing ends synchronizing a file to a newer version
ItemStarted				// Generated when Syncthing begins synchronizing a file to a newer version
LocalIndexUpdated		// Generated when the local index information has changed, due to synchronizing one or more items from the cluster or discovering local changes during a scan
RemoteIndexUpdated		// Generated each time new index information is received from a device
Starting				// Emitted exactly once, when Syncthing starts, before parsing configuration etc
StartupCompleted		// Emitted exactly once, when initialization is complete and Syncthing is ready to start exchanging data with other devices
StateChanged			// Emitted when a folder changes state
FolderErrors			// Emitted when a folder has errors preventing a full sync
FolderScanProgress		// Emitted every ScanProgressIntervalS seconds, indicating how far into the scan it is at.
FolderPaused			// Emitted when a folder is paused
FolderResumed			// Emitted when a folder is resumed
*/
